const newProductMap = {
  gia: true,
}

export default newProductMap
